import { Button, Space, Checkbox, Tag } from "antd";
// import "../../assets/styles/banks.css"
import { Tooltip, Typography } from "antd";

// import { TagGoodsReceiptStatus } from "../../components/badge-and-tag";
import {
  EditableRow,
  EditableCell,
} from "../../../components/table/TableEditAble";
import dayjs from "dayjs";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import { TbClipboardCheck, TbBarcode } from "react-icons/tb";
import { formatMoney, BACKEND_URL_MAIN } from "../../../utils/util";
import { TagsCreateBy } from "../../../components/badge-and-tag/";

import DocLink, { docLinkRender } from "../../../components/table/DocLink";
// import { TbShoppingCartCopy } from "react-icons/tb";

/** export component for edit table */
export const componentsEditable = {
  body: { row: EditableRow, cell: EditableCell },
};

/** get sample column */
export const accessColumn = ({
  handleEdit,
  handleDelete,
  handleView,
  handlePrinter,
  handleQc,
  handleTags,
}) => [
  {
    title: "รหัส",
    key: "code",
    dataIndex: "code",
    width: 80,
    align: "center",
    hidden: "true",
  },
  {
    title: "รหัสใบรับสินค้า",
    key: "grcode",
    dataIndex: "grcode",
    align: "left",
    sorter: (a, b) => a.grcode.localeCompare(b.grcode),
    width: 140,
    /* กดเลขที่เอกสารเพื่อเปิดหน้าแสดงข้อมูล */
    render: docLinkRender(handleView, "เปิดดูใบรับสินค้า"),
  },
  {
    title: "วันที่ใบรับสินค้า",
    dataIndex: "grdate",
    key: "grdate",
    width: 140,
    sorter: (a, b) => a.grdate.localeCompare(b.grdate),
    render: (v) => dayjs(v).format("DD/MM/YYYY"),
  },
  {
    /* เลขที่เอกสารของผู้จำหน่ายที่แนบมากับของ (er_grmaster.inv_no)
       เว้นว่างได้ จึงต้องกัน null ตอน sort */
    title: "เลขที่ Inv/ใบส่งของ",
    dataIndex: "inv_no",
    key: "inv_no",
    align: "left",
    width: 160,
    sorter: (a, b) => String(a.inv_no || "").localeCompare(String(b.inv_no || "")),
    ellipsis: {
      showTitle: false,
    },
    render: (v) =>
      v ? (
        <Tooltip placement="topLeft" title={v}>
          {v}
        </Tooltip>
      ) : (
        <Typography.Text type="secondary">-</Typography.Text>
      ),
  },
  {
    title: "รหัสผู้ขาย",
    dataIndex: "supcode",
    key: "supcode",
    width: 120,
    sorter: (a, b) => a.supcode.localeCompare(b.supcode),
  },
  {
    title: "ชื่อผู้ขาย",
    dataIndex: "supname",
    key: "supname",
    sorter: (a, b) => a.supname.localeCompare(b.supname),
    ellipsis: {
      showTitle: false,
    },
    render: (v) => (
      <Tooltip placement="topLeft" title={v}>
        {v}
      </Tooltip>
    ),
  },
  {
    title: "จัดทำโดย",
    dataIndex: "created_name",
    key: "created_name",
    sorter: (a, b) => a.created_name.localeCompare(b.created_name),
    width: "15%",
    ellipsis: {
      showTitle: false,
    },
    render: (data, role) => <TagsCreateBy result={data} role={role} />,
  },
  {
    title: "COA",
    dataIndex: "coa_status",
    key: "coa_status",
    align: "center",
    width: 60,
    sorter: (a, b) => Number(a.coa_status || 0) - Number(b.coa_status || 0),
    render: (v) => (
      <Checkbox checked={Number(v) > 0} disabled={Number(v) <= 0} />
    ),
  },
  {
    /* แยก Tags แล้วหรือยัง — นับจากป้ายที่บันทึกไว้ใน er_gr_tags */
    title: "แยก Tags",
    dataIndex: "tag_count",
    key: "tag_count",
    align: "center",
    width: 110,
    sorter: (a, b) => Number(a.tag_count || 0) - Number(b.tag_count || 0),
    render: (v) =>
      Number(v) > 0 ? (
        <Tag color="blue">{`แยกแล้ว ${Number(v)} ป้าย`}</Tag>
      ) : (
        <Tag color="default">ยังไม่แยก</Tag>
      ),
  },
  {
    /* สถานะการรับเข้า : 'ยกเลิก' = ของถูกถอนออกจากสต๊อกแล้ว รอแก้ไขและรับเข้าใหม่ */
    title: "สถานะ",
    key: "doc_status",
    dataIndex: "doc_status",
    width: 130,
    align: "center",
    render: (v) =>
      v === "ยกเลิก" ? (
        <Tag color="red">ยกเลิกการรับเข้า</Tag>
      ) : (
        <Tag color="green">รับสินค้าแล้ว</Tag>
      ),
  },
  {
    title: "Action",
    key: "operation",
    fixed: "right",
    width: 180,
    render: (text, record) => (
      <Space>
        <Tooltip title="ดูข้อมูลใบรับสินค้า">
          <Button
            icon={<EyeOutlined />}
            className="bn-info-outline"
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={(e) => handleView(record)}
            size="small"
          />
        </Tooltip>
        <Button
          icon={<EditOutlined />}
          className="bn-primary-outline"
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={(e) => handleEdit(record)}
          size="small"
        />
        <Tooltip title="บันทึกตรวจรับวัตถุดิบ (QC)">
          <Button
            icon={<TbClipboardCheck style={{ fontSize: "1rem" }} />}
            className="bn-success-outline"
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={(e) => handleQc(record)}
            size="small"
          />
        </Tooltip>
        <Tooltip title="แยก Tags / พิมพ์ Barcode">
          <Button
            icon={<TbBarcode style={{ fontSize: "1rem" }} />}
            className="bn-info-outline"
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={(e) => handleTags(record)}
            size="small"
          />
        </Tooltip>
      </Space>
    ),
  },
];

export const productColumn = ({ handleAction, handleAdjust }, optionsItems) => [
  {
    title: "ลำดับ",
    dataIndex: "ind",
    key: "ind",
    align: "center",
    width: 80,
    render: (im, rc, index) => <>{index + 1}</>,
  },
  {
    title: "ใบสั่งซื้อ",
    dataIndex: "pocode",
    key: "pocode",
    width: 120,
    align: "center",
  },
  {
    title: "รหัสสินค้า",
    dataIndex: "stcode",
    key: "stcode",
    width: 120,
    align: "center",
  },
  {
    title: "ชื่อสินค้า",
    dataIndex: "purdetail",
    key: "purdetail",
    align: "left",
    render: (_, rec) => rec.stname,
  },
  {
    title: "ประเภทสินค้า",
    dataIndex: "typename",
    key: "typename",
    align: "center",
    width: "6%",
    render: (_, rec) => rec.typename,
  },
  {
    title: "ราคาต่อหน่วย",
    dataIndex: "price",
    key: "price",
    width: "10%",
    align: "right",
    className: "!pe-3",
    type: "number",
    render: (_, rec) => <>{formatMoney(Number(rec?.price || 0), 2, 2)}</>,
  },
  {
    title: "ส่วนลด",
    dataIndex: "discount",
    key: "discount",
    width: "7%",
    align: "right",
    className: "!pe-3",
    type: "number",
    render: (_, rec) => <>{formatMoney(Number(rec?.discount || 0), 2, 2)}</>,
  },
  {
    title: "หน่วยสินค้า",
    dataIndex: "unit",
    key: "unit",
    align: "right",
    width: "8%",
    type: "select",
    optionsItems,
    render: (v) => {
      return optionsItems?.find((f) => f.value === v)?.label;
    },
  },
  // {
  //   title: "จำนวนที่สั่ง",
  //   dataIndex: "qty_buy",
  //   key: "qty_buy",
  //   width: "10%",
  //   align: "right",
  //   className: "!pe-3",
  //   type: 'number',
  //   render: (_, rec) => <>{formatMoney(Number(rec?.qty_buy || 0), 2, 2)}</>,
  // },
  {
    title: "จำนวนที่สั่ง/จำนวนที่รับแล้ว",
    dataIndex: "recamount",
    key: "recamount",
    width: "10%",
    align: "center",
    className: "!pe-3",
    type: "number",
    render: (_, rec) => (
      <>
        {formatMoney(Number(rec?.qty_buy || 0), 2, 2) +
          "/" +
          formatMoney(Number(rec?.recamount || 0), 2, 2)}
      </>
    ),
  },
  {
    title: "จำนวนที่จะรับ",
    dataIndex: "qty",
    key: "qty",
    width: "8%",
    align: "right",
    className: "!pe-3",
    editable: true,
    required: true,
    type: "number",
    render: (_, rec) => <>{formatMoney(Number(rec?.qty || 0))}</>,
  },
  {
    title: "ตัวเลือก",
    align: "center",
    key: "operation",
    dataIndex: "operation",
    render: (_, record, idx) => handleAction(record),
    width: "90px",
    fixed: "right",
  },
  {
    title: "Action",
    key: "operation",
    fixed: "right",
    width: 100,
    render: (text, record) => (
      <Space>
        {/* <Button
          icon={<EditOutlined />} 
          className='bn-primary-outline'
          style={{ cursor: "pointer", display: 'flex', alignItems: 'center', justifyContent: 'center'}}
          onClick={(e) => handleEdit(record) }
          size="small"
        /> */}

        <Typography.Link
          className="hover:!underline flex items-center gap-1"
          onClick={() => handleAdjust(record)}
        >
          <EditOutlined /> แก้วันหมดอายุ
        </Typography.Link>
      </Space>
    ),
  },
];

/* ============================================================
   คอลัมน์ตารางรายการสำหรับ "หน้าแสดงข้อมูล" (อ่านอย่างเดียว)
   openPo = กดเลขที่ใบสั่งซื้อเพื่อเปิดหน้าแสดงข้อมูลใบสั่งซื้อนั้น
            (ไม่ส่งมาก็ได้ จะแสดงเป็นข้อความธรรมดา)
============================================================ */
export const productColumnView = (optionsItems = [], { openPo } = {}) => [
  {
    title: "ลำดับ",
    dataIndex: "ind",
    key: "ind",
    align: "center",
    width: 60,
    render: (_v, _rc, index) => index + 1,
  },
  {
    title: "ใบสั่งซื้อ",
    dataIndex: "pocode",
    key: "pocode",
    width: 130,
    align: "center",
    render: (v, record) =>
      typeof openPo === "function" ? (
        <DocLink
          value={v}
          record={record}
          onClick={openPo}
          title="เปิดดูใบสั่งซื้อ"
        />
      ) : (
        v || "-"
      ),
  },
  {
    title: "รหัสสินค้า",
    dataIndex: "stcode",
    key: "stcode",
    width: 120,
    align: "center",
  },
  {
    title: "ชื่อสินค้า",
    dataIndex: "stname",
    key: "stname",
    align: "left",
  },
  {
    title: "ประเภทสินค้า",
    dataIndex: "typename",
    key: "typename",
    align: "center",
    width: 120,
  },
  {
    title: "จำนวนที่สั่ง",
    dataIndex: "qty_buy",
    key: "qty_buy",
    width: 110,
    align: "right",
    className: "!pe-3",
    render: (v) => formatMoney(Number(v || 0), 2),
  },
  {
    title: "จำนวนที่รับ",
    dataIndex: "qty",
    key: "qty",
    width: 110,
    align: "right",
    className: "!pe-3",
    render: (v) => (
      <span style={{ fontWeight: 600 }}>{formatMoney(Number(v || 0), 2)}</span>
    ),
  },
  {
    title: "หน่วย",
    dataIndex: "unit",
    key: "unit",
    align: "center",
    width: 90,
    render: (v) => optionsItems?.find((f) => f.value === v)?.label ?? v,
  },
  {
    title: "ราคา/หน่วย",
    dataIndex: "price",
    key: "price",
    width: 110,
    align: "right",
    className: "!pe-3",
    render: (v) => formatMoney(Number(v || 0), 2),
  },
  {
    title: "ส่วนลด",
    dataIndex: "discount",
    key: "discount",
    width: 100,
    align: "right",
    className: "!pe-3",
    render: (v) => formatMoney(Number(v || 0), 2),
  },
  {
    title: "รวม",
    dataIndex: "total",
    key: "total",
    width: 110,
    align: "right",
    className: "!pe-3",
    render: (_v, rec) =>
      formatMoney(
        Number(rec?.qty || 0) * Number(rec?.price || 0) -
          Number(rec?.discount || 0),
        2
      ),
  },
];

/* ล็อต / วันหมดอายุ ที่กางออกมาใต้แต่ละรายการในหน้าแสดงข้อมูล */
export const expireColumnView = [
  {
    title: "ลำดับ",
    dataIndex: "seq",
    key: "seq",
    align: "center",
    width: 70,
  },
  {
    title: "Lot No.",
    dataIndex: "lot_no",
    key: "lot_no",
    width: 180,
  },
  {
    title: "จำนวน",
    dataIndex: "list_qty",
    key: "list_qty",
    align: "right",
    width: 120,
    className: "!pe-3",
    render: (v) => formatMoney(Number(v || 0), 2),
  },
  {
    title: "วันที่ผลิต",
    dataIndex: "mfg_date",
    key: "mfg_date",
    align: "center",
    width: 140,
    render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "-"),
  },
  {
    title: "วันหมดอายุ",
    dataIndex: "expire_date",
    key: "expire_date",
    align: "center",
    width: 140,
    render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "-"),
  },
];

/* readOnly = โหมดแก้ไขใบรับสินค้า : ล็อกรายการสินค้าทั้งหมด
   (แก้จำนวน/ราคา/ล็อต ไม่ได้ เพราะกระทบสต๊อกและยอดรับของใน PO) */
export const columnsParametersEditable = (
  handleSave,
  optionsItems,
  { handleAction, handleAdjust, readOnly = false }
) => {
  const col = productColumn({ handleAction, handleAdjust }, optionsItems);
  return col.map((col, ind) => {
    if (readOnly || !col.editable) return col;

    return {
      ...col,
      onCell: (record) => {
        // console.log(record);
        // ไม่ล็อกเพดานจำนวนที่จะรับ — รับเกินจำนวนที่สั่งได้
        let prop = {};

        /* สีบอกสถานะช่อง "จำนวนที่จะรับ"
           เขียว = ครบพอดี, ส้ม = รับเกิน, แดง = ยังไม่ครบ */
        let className;
        if (col.dataIndex === "qty") {
          const qty = Number(record?.qty || 0);
          const buy = Number(record?.qty_buy || 0);
          const tone =
            qty > buy && buy > 0
              ? "text-orange-600"
              : qty > 0 && qty >= buy
              ? "text-green-700"
              : "text-red-600";
          className = `!pe-3 field-edit !bg-gray-300 ${tone}`;
        }

        return {
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          // required: !!col?.required,
          type: col?.type || "input",
          handleSave,
          optionsItems,
          childProps: prop,
          ...(className ? { className } : {}),
        };
      },
    };
  });
};
/* รายการสินค้าในใบรับสินค้า — ใช้ตอนกางแถว (ปุ่ม +) หน้าจัดการใบรับสินค้า
   1 แถว = 1 lot ของสินค้าแต่ละรายการ */
export const accessDetailColumn = [
  { title: "No.", dataIndex: "no", key: "no", width: 60, align: "center" },
  { title: "รหัสสินค้า", dataIndex: "stcode", key: "stcode", width: 130 },
  { title: "ชื่อสินค้า", dataIndex: "stname", key: "stname", width: 260 },
  { title: "เลขที่ PO", dataIndex: "pocode", key: "pocode", width: 130 },
  {
    title: "เลขที่ Lot",
    dataIndex: "lot_no",
    key: "lot_no",
    width: 150,
    render: (v) => v || "-",
  },
  {
    title: "Express Lot",
    dataIndex: "express_lot",
    key: "express_lot",
    width: 140,
    render: (v) => v || "-",
  },
  {
    title: "จำนวน",
    dataIndex: "list_qty",
    key: "list_qty",
    width: 110,
    align: "right",
    render: (v, rec) => formatMoney(Number(v ?? rec?.qty ?? 0), 2, 2),
  },
  { title: "หน่วย", dataIndex: "unit", key: "unit", width: 90, align: "center" },
  {
    title: "วันที่ผลิต",
    dataIndex: "mfg_date",
    key: "mfg_date",
    width: 120,
    align: "center",
    render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "-"),
  },
  {
    title: "วันหมดอายุ",
    dataIndex: "expire_date",
    key: "expire_date",
    width: 120,
    align: "center",
    render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "-"),
  },
];

export const goodsreceiptForm = {
  grcode: null,
  grdate: null,
  supcode: null,
  supname: null,
  contact: null,
  supcontact: null,
  supaddress: null,
  tel: null,
  remark: null,
  discount: 0,
  total_price: 0,
  vat: 7,
  grand_total_price: 0,
};

export const goodsreceiptDetailForm = {
  grcode: null,
  stcode: null,
  stname: null,
  discount: 0,
  qty: 0,
  price: 0,
  unit: null,
};
